<template>
  <div v-if="items.length != 0">
    <div
      class="font-weight-bold black--text"
      style="font-size: 18px"
      :class="$vuetify.breakpoint.xsOnly ? 'mb-2' : ''"
    >
      Top-Performing SEBI Reg. Experts
    </div>

    <v-row class="ma-0" v-if="loading && page === 1">
      <v-col cols="6" md="4" v-for="item in 3" :key="item">
        <v-card class="mt-2">
          <v-skeleton-loader type="image, article" />
        </v-card>
      </v-col>
    </v-row>
    <div v-else>
      <Flicking
        v-if="items.length > 5"
        :options="{
          align: align,
          circular: true,
          autoResize: true,
          bound: false,
          gap: 10,
          moveType: 'freeScroll',
          animationDuration: 0,
          stopOnHover: true,
          duration: 500,
          perspective: 50,
        }"
        :plugins="plugins"
      >
        <div class="pa-1" v-for="(item, index) in items" :key="index">
          <PerformingTraderCard class="mt-2" :profile_data="item" />
        </div>
        <span
          slot="viewport"
          class="flicking-arrow-prev is-thin is-circle"
        ></span>
        <span
          slot="viewport"
          class="flicking-arrow-next is-thin is-circle"
        ></span>
      </Flicking>
      <div v-else class="d-flex">
        <div class="pa-1" v-for="(item, index) in items" :key="index">
          <PerformingTraderCard class="mt-2" :profile_data="item" />
        </div>
      </div>
    </div>
    <v-col class="mt-4" v-if="isNextPage !== null">
      <!-- <v-btn
        color="white"
        block
        :loading="loading"
        @click="nextPage"
        class="primary--text font-weight-bold text-capitalize body-1"
      >
        Show More
      </v-btn> -->
    </v-col>
  </div>
</template>

<script>
import PerformingTraderCard from "@/components/Trending/PerformingTrader/PerformingTraderCard.vue";
import { Fade, AutoPlay, Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
export default {
  components: { PerformingTraderCard },
  data: () => ({
    performingTradersLoading: false,
    my_item: {},
    plugins: [new Fade(), new AutoPlay(0, 0, "NEXT", true), new Arrow()],
    align: {
      camera: "50%",
      panel: "50%",
    },
  }),
  computed: {
    page: {
      get() {
        return this.$store.state.performingTraders.page;
      },
      set(value) {
        this.$store.commit("performingTraders/setPage", value);
      },
    },
    isNextPage: {
      get() {
        return this.$store.state.performingTraders.isNextPage;
      },
      set(value) {
        this.$store.commit("performingTraders/setIsNextPage", value);
      },
    },
    getItems: {
      get() {
        return this.$store.state.performingTraders.allItems;
      },
    },
    items() {
      // console.log(this.$store.state.performingTraders.allItems);
      return this.$store.state.performingTraders.allItems;
    },
    loading() {
      return this.$store.state.performingTraders.loading;
    },
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.$store.dispatch("performingTraders/getPerformingTraders", {});
    },
    nextPage() {
      if (this.isNextPage !== null) this.page++;
    },
  },
  mounted() {
    this.$store.dispatch("trendingTrades/resetPage");
    this.my_item = this.items;
    console.log(this.items.length);
    if (this.items.length == 0) {
      this.getData();
    }
  },
  beforeDestroy() {
    this.$store.dispatch("trendingTrades/resetPage");
  },
};
</script>

<style scoped>
.flicking-arrow-prev.is-circle,
.flicking-arrow-next.is-circle {
  background-color: white !important;
  border-radius: 50% !important;
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flicking-arrow-prev::before,
.flicking-arrow-next::before {
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  content: "";
  display: block !important;
  position: absolute;
  transform-origin: 100% 50%;
  transform: rotate(-45deg);
  right: 22px;
}

.flicking-arrow-prev::after,
.flicking-arrow-next::after {
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  content: "" !important;
  display: block !important;
  position: absolute !important;
}

.flicking-arrow-prev::after {
  margin-left: -12px !important;
  transform-origin: 100% 50%;
  transform: rotate(135deg);
  right: 22px;
}

.flicking-arrow-prev::before {
  margin-left: -12px !important;
  transform-origin: 100% 50%;
  transform: rotate(-135deg);
  right: 22px;
}

.flicking-arrow-next::after {
  transform-origin: 100% 50%;
  transform: rotate(45deg);
  right: 22px;
  margin-right: -12px !important;
  position: absolute;
  height: 3px !important;
  width: 14px !important;
  display: block !important;
  position: absolute;
}

.flicking-arrow-next::before {
  transform-origin: 100% 50%;
  transform: rotate(-45deg);
  right: 22px;
  margin-right: -12px !important;
  top: 50% !important;
  right: 22px !important;
  transform-origin: 100% 50%;
}

.flicking-arrow-prev.is-circle::before,
.flicking-arrow-next.is-circle::before {
  position: absolute !important;
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  display: block !important;
}

.flicking-arrow-next {
  position: absolute;
  top: 50% !important;
  cursor: pointer !important;
  transform: translateY(-50%) !important;
  z-index: 2;
  right: 10px !important;
}

.flicking-arrow-prev {
  position: absolute !important;
  top: 50% !important;
  cursor: pointer !important;
  transform: translateY(-50%) !important;
  z-index: 2 !important;
  right: 10px !important;
  left: 10px !important;
}

.flicking-arrow-prev.is-thin::after,
.flicking-arrow-next.is-thin::after {
  top: calc(50% - -1px);
}
</style>
